// extracted by mini-css-extract-plugin
export var bodySections = "_c3-8";
export var gray = "_c3-7";
export var green = "_c3-4";
export var iconContainer = "_c3-9";
export var iconWidgetContainer = "_c3-1";
export var phoneIcon = "_c3-2";
export var red = "_c3-5";
export var statusDot = "_c3-3";
export var widgetContainer = "_c3-0";
export var yellow = "_c3-6";